// src/config/uaPayment.js
// Utility Allowance onboarding payment config: the ONE place to set up
// checkout. Create two Stripe Payment Links (Dashboard → Payment Links →
// + New) and paste their URLs below:
//   member:   $300/yr, Section 8 Administrators member rate
//   standard: $350/yr, standard rate
//
// After the join form is submitted it always lands on the internal payment
// page (/utility-allowances/join/payment), which offers Stripe checkout as the
// primary action plus an alternative-payment request. While the links below
// are empty, that page shows the amount and a contact fallback instead of a
// dead button.
//
// Tip: in each Payment Link's settings, set the after-payment confirmation
// page to https://gethousingai.com/utility-allowances so buyers land back
// on the site.

export const PAYMENT_LINKS = {
  member: 'https://buy.stripe.com/28E7sEgy93GO7vNbpugEg00',    // $300/yr, Section 8 Administrators member rate
  standard: 'https://buy.stripe.com/eVq14g2Hj1yGeYfalqgEg01',  // $350/yr, standard rate
};

// Annual subscription, billed every 12 months via Stripe.
export const PRICES = { member: 300, standard: 350 };

// After the form, the visitor always lands on the internal payment page.
// member=yes|no selects the rate. joinId and email are optional: the payment
// page normally reads the saved join-request info from localStorage, so these
// URL params are just a fallback and can be omitted.
export function paymentDestination(isMember, origin, joinId, email) {
  const params = new URLSearchParams({ member: isMember ? 'yes' : 'no' });
  if (joinId) params.set('jid', String(joinId));
  if (email) params.set('email', email);
  return `${origin}/utility-allowances/join/payment?${params.toString()}`;
}